import {useMutation, useQuery} from '@apollo/client'
import {GET_USER_SUB_AREA_ATUACAO} from '../query'
import {TypesGetSubAreaAtuacaoResponse, TypesSetUserSubAreaAtuacaoResponse} from '../type'
import {SET_USER_SUB_AREA_ATUACAO} from '../mutations'
import {setUserSubAreaAtuacaoFormData, setUserSubAreaAtuacaoFormSchema} from '../formValidations'
import {zodResolver} from '@hookform/resolvers/zod'
import {useForm} from 'react-hook-form'

interface QueryUserSubAreaAtuacaoProps {
  variables: any
}

export function QueryGetUserSubAreaAtuacao({variables}: QueryUserSubAreaAtuacaoProps) {
  const {data, loading, error} = useQuery<TypesGetSubAreaAtuacaoResponse>(
    GET_USER_SUB_AREA_ATUACAO,
    {
      variables: {...variables},
    }
  )
  return {data, loading, error}
}

export function MutationCreateUserSubAreaAtuacao() {
  const {
    register,
    handleSubmit,
    formState: {errors},
  } = useForm<setUserSubAreaAtuacaoFormData>({
    resolver: zodResolver(setUserSubAreaAtuacaoFormSchema),
  })

  const [setBody, {error, loading, data: DataSet}] =
    useMutation<TypesSetUserSubAreaAtuacaoResponse>(SET_USER_SUB_AREA_ATUACAO, {
      refetchQueries: [GET_USER_SUB_AREA_ATUACAO],
    })

  async function Form(data: setUserSubAreaAtuacaoFormData) {
    return await setBody({
      variables: {data},
    })
  }

  return {register, handleSubmit, Form, loading, errors, error, DataSet}
}
